import DrawerComponent from 'components/Drawer';
import DryEventContent from 'screens/awd-dashboard/components/task-drawer/DryEventContent';
import PipeInstallationContent from 'screens/awd-dashboard/components/task-drawer/PipeInstallationContent';
import useSeasonByIdQuery from '../hooks/queries/useSeasonByIdQuery';

type RedirectedContentDrawerProps = {
  open: boolean;
  seasonId: string;
  taskType: string;
  onClose?: () => void;
};

const RedirectedContentDrawer = ({
  open,
  seasonId,
  taskType,
  onClose,
}: RedirectedContentDrawerProps) => {
  const { data } = useSeasonByIdQuery(seasonId);

  const task = data?.taskAssignments?.filter(
    (task) => task.description === taskType,
  )?.[0];

  const renderDrawerContent = () =>
    task?.taskSubType === 'PIPE_INSTALLATION' ? (
      <PipeInstallationContent data={{ task: task, season: data }} />
    ) : task?.taskSubType == 'VISIT_30' ||
      task?.taskSubType.startsWith('DRYING_EVENT') ? (
      <DryEventContent data={{ task: task, season: data }} />
    ) : null;

  return (
    <DrawerComponent
      open={open}
      title={task?.description}
      onClose={onClose}
      content={renderDrawerContent()}
    />
  );
};

export default RedirectedContentDrawer;
